import { Reveal, SectionLabel } from "@/components/site/Reveal";
import { FlaskConical, Gift, Users, Clock, ArrowRight } from "lucide-react";

export const TestLabSection = ({ detailed = false }) => {
  const steps = [
    { n: "01", title: "We test it", desc: "The Fish House Project tests the product first, in our own tanks." },
    { n: "02", title: "Community tests it", desc: "A community member receives a second unit to test in their own aquarium." },
    { n: "03", title: "Honest verdict", desc: "Four weeks later, the community tester shares their honest experience." },
  ];

  return (
    <section className="py-24 lg:py-32 relative overflow-hidden" data-testid="testlab-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-3xl">
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="h-8 w-8 grid place-items-center rounded-full bg-brand-cyan/15 text-brand-cyan">
              <FlaskConical size={16} />
            </span>
            <span className="text-[10px] uppercase tracking-[0.24em] bg-brand-cyan/15 text-brand-cyan px-3 py-1 rounded-full font-semibold">
              Coming Soon
            </span>
          </div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            THE FISH HOUSE TEST LAB
          </h2>
          <p className="mt-6 text-brand-textSec leading-relaxed">
            A future feature of the project. The Fish House Project will eventually test aquarium products in
            two stages — and let the community test them too.
          </p>
          <p className="mt-5 font-display font-bold text-xl text-brand-cyan">
            Test it ourselves. Then let the community test it.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div className="card-surface p-7 h-full">
                <span className="font-display font-extrabold text-brand-cyan text-2xl">{s.n}</span>
                <h3 className="mt-3 font-display font-semibold text-white text-lg">{s.title}</h3>
                <p className="mt-2 text-brand-textSec text-sm leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {detailed && (
          <>
            <Reveal>
              <div className="mt-14 card-surface p-8 sm:p-10">
                <h3 className="font-display font-semibold text-white text-lg mb-4">What each product page will show</h3>
                <div className="flex flex-wrap gap-2.5">
                  {["Product", "Manufacturer", "My review", "Community tester", "Community review", "Test duration", "Pros", "Cons", "Scores", "Final verdict", "Video links"].map((f) => (
                    <span key={f} className="text-sm text-brand-textSec border border-white/10 rounded-full px-4 py-2">{f}</span>
                  ))}
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.1}>
              <div className="mt-8 grid md:grid-cols-2 gap-6">
                <div className="card-surface p-7">
                  <span className="h-10 w-10 grid place-items-center rounded-full bg-brand-cyan/10 text-brand-cyan mb-4">
                    <Gift size={20} />
                  </span>
                  <h3 className="font-display font-semibold text-white text-lg">Community Giveaways (Future)</h3>
                  <p className="mt-2 text-brand-textSec text-sm leading-relaxed">
                    Some future Test Lab products may include community giveaways: a manufacturer provides two
                    units — one tested by the project, one given to a community member who tests it for around
                    four weeks and gives an honest review. Not live yet.
                  </p>
                </div>
                <div className="card-surface p-7">
                  <span className="h-10 w-10 grid place-items-center rounded-full bg-brand-cyan/10 text-brand-cyan mb-4">
                    <Clock size={20} />
                  </span>
                  <h3 className="font-display font-semibold text-white text-lg">Roughly Four Weeks</h3>
                  <p className="mt-2 text-brand-textSec text-sm leading-relaxed">
                    Real-world testing takes time. Community testers will run products for approximately four
                    weeks before reporting back — no rushed reviews, no fake hype.
                  </p>
                </div>
              </div>
            </Reveal>
          </>
        )}

        {!detailed && (
          <Reveal delay={0.2}>
            <a href="/test-lab" className="mt-10 inline-flex items-center gap-2 text-brand-cyan text-sm font-medium hover:gap-3 transition-all" data-testid="testlab-learn-more">
              Learn more about the Test Lab <ArrowRight size={16} />
            </a>
          </Reveal>
        )}
      </div>
    </section>
  );
};
